<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                v-model="queryForm.qstr"
                placeholder="名稱"
                size="small"
                style="width:100px"
              ></el-input>
            </el-form-item>

            <el-form-item label="顏色" label-width="65px">
              <div
                style="width:335px;marginBottom:-20px"
                >
                <el-checkbox-group v-model="queryForm.colors">
                  <el-checkbox
                    v-for="itemColor in extTagColorList"
                    :key="itemColor.name"
                    :label="itemColor.name"
                    style="width:35px"
                  >
                    <span :style="{ color: itemColor.textColor, marginLeft: '-5px'}" >
                      {{ itemColor.txtLabel }}
                    </span>
                  </el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                style="marginLeft:-10px"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addNewChnl"
            size="small"
            >新增頻道</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 單位：{{ myownOrg }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="channels"
            @sort-change="sortChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="index" :index="indexFormatter" fixed>
            </el-table-column>

            <el-table-column
              label="頻道名稱"
              prop="name"
              sortable="custom"
              width="250"
            >

              <template #default="scope">
               <el-tooltip v-if="scope.row.isSystem" content="系統頻道，勿公開、勿分享">
                <el-tag :style="getTagStyle(scope.row.color)"
                  ><i  class="el-icon-setting"></i>{{ scope.row.name }}</el-tag>
               </el-tooltip>
                <el-tag v-else
                  :style="getTagStyle(scope.row.color)"
                  >{{ scope.row.name }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column width="230" label="公開頻道">
              <template #default="scope">
                <el-switch
                  :value="scope.row.isPublic"
                  active-text="公開"
                  inactive-text="非公開"
                  disabled
                >
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column
              label="管理員"
              prop="channelUsers"
              :sortable="false"
              width="200"
            >
              <template #default="scope">
                <el-tag effect="plain" type="info" v-for="channelUser in scope.row.channelUsers"
                    :key="channelUser.id"
                    :label="channelUser.user.name"
                  >{{ channelUser.user.name }}</el-tag>
              </template>
            </el-table-column>
            <!--<el-table-column width="230" label="頻道管理員可個人授權">-->
              <!--<template #default="scope">-->
                <!--<el-switch-->
                  <!--:value="scope.row.enableAssign"-->
                  <!--active-text="啟用"-->
                  <!--inactive-text="關閉"-->
                  <!--disabled >-->
                <!--</el-switch>-->
              <!--</template>-->
            <!--</el-table-column>-->

            <el-table-column label="操作">
              <template #default="scope">
                <el-button size="mini" @click="changeChnlAdmin(scope.row)"
                  >設定頻道管理員
                </el-button>
                <el-button size="mini" @click="editChannel(scope.row.id)"
                  >編輯
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="delChannel(scope.row.id)"
                  >刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10, 25, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
        <AddEdtChnlDlg
          v-model="isDlgVisible"
          :selectedItemId="selectedItemId"
          :key="`chnlDlg_${dlgKey}`"
        ></AddEdtChnlDlg>
        <EditChnlAdminDlg
          v-model="isEdtChnlAdmDlgVisible"
          :channelId="selectedItemId"
          :chnlName="selChnlName"
          :key="`admDlg_${edtAdmDlgKey}`"
        ></EditChnlAdminDlg>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import appConfig from "../appConfig"
import AddEdtChnlDlg from "@/components/org/AddEdtChnlDlg";
import EditChnlAdminDlg from "@/components/org/EditChnlAdminDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  name: "orgChnlList",
  mixins: [tagColorsMixin],
  components: {
    AddEdtChnlDlg,
    EditChnlAdminDlg,
  },
  created() {
    this.$store.commit("channel/CLEAR");
    this.$store.commit("channel/SET_SORT", this.defaultSortCol);
    this.$store.commit("channel/SET_ORDER", this.defaultOrder);
    this.query(this.pageSize, this.offset, this.sort, this.order);
  },
  data() {
    return {
      defaultSortCol: "id",
      defaultOrder: 'ascending',
      selectedItemId: null,
      selChnlName: "",
      dlgKey: 0,
      edtAdmDlgKey: 0,
      isDlgVisible: false,
      isEdtChnlAdmDlgVisible: false,
      pageSize: 10,
      currentPage: 1,
      queryForm: {
        qstr: "",
        colors: [],
      },
      activeQueryForm: {
        qstr: "",
        colors: [],
      },
    };
  },
  methods: {
    changeChnlAdmin(chnl) {
      this.selectedItemId = chnl.id;
      this.selChnlName = chnl.name;
      this.edtAdmDlgKey = this.edtAdmDlgKey ? 0 : 1;
      this.isEdtChnlAdmDlgVisible = true;
    },
    getAdminNames(admins) {
      return admins.reduce((acc, cur) => {
        return `${acc}${cur.name}; `;
      }, "");
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    },
    addNewChnl() {
      this.isDlgVisible = true;
      this.selectedItemId = null;
      this.dlgKey = this.dlgKey ? 0 : 1;
    },
    editChannel(itemId) {
      /*console.log(`editChannel: itemId = ${itemId}`);*/
      this.selectedItemId = itemId;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      let newParams = {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      };

      if (this.myownOrg !== appConfig.SYS_ORG_NAME) {
        newParams.scope = "internal";
      }

      this.$store.dispatch("channel/list", {
        ...newParams
      });
    },

    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    delChannel(itemId) {
      this.$confirm("此操作將永久刪除該頻道, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("channel/remove", itemId).then(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.activeQueryForm
            );
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("channel/SET_SORT", this.defaultSortCol);
        this.$store.commit("channel/SET_ORDER", this.defaultOrder);
      } else {
        this.$store.commit("channel/SET_SORT", args.prop);
        this.$store.commit("channel/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      channels: "channel/channels",
      total: "channel/total",
      max: "channel/max",
      offset: "channel/offset",
      sort: "channel/sort",
      order: "channel/order",
    }),
  },
};
</script>

<style></style>
